import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'

export function getIntervalDurationLimits(timerType, duration, maxDuration) {
  if (timerType === PRACTICE_TIMER_TYPES.range) {
    return { min: duration, max: maxDuration }
  }
  if (timerType === PRACTICE_TIMER_TYPES.unlimited) {
    return { min: Number.MAX_SAFE_INTEGER, max: Number.MAX_SAFE_INTEGER }
  }
  return { min: duration, max: duration }
}
